import { IFilterBody } from 'components/filter/models/TableFilterModels';
import alb from 'services/api/alb';
import api from 'services/api/api';
import {
	IRequestCheckTableBody,
	QueryTypeModule,
} from 'services/queryClient/wrapperHooks/genericTables/useGetCheckTableDataWithFilters';
interface IFetchDataByFiltersOutput<T> {
	data: Array<T>;
	filterMap: IFilterBody[];
	dependencias: string[];
	count: number;
}
export const fetchDataByFilters = async <T>(
	module: QueryTypeModule,
	body: IRequestCheckTableBody
): Promise<IFetchDataByFiltersOutput<T>> => {
	const url = `/${module}/view`;
	const response = await api.post(url, body);
	return response.data;
};

export const fetchDataByFiltersAiPrediction = async ({ page, page_size }) => {
	const response = await alb.get('/core/ai-prediction/view', {
		params: {
			page,
			page_size,
		},
	});

	return {
		data: response?.data?.data,
		dependencias: [],
		filterMap: [],
		count: response?.data.count_lines,
	};
};
